import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { Spacer } from 'jbc-front/components/presenters/Spacer';
import { Label } from 'jbc-front/components/presenters/form/Label';
import { Textarea } from 'jbc-front/components/presenters/form/Textarea';
import { Radio, RadioContainer } from 'jbc-front/components/presenters/form/Radio';
import { ErrorMessage } from 'jbc-front/components/presenters/form/ErrorMessage';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import type { Schema } from '../../schema';

export const BloodLipidTest: FC = () => {
  const {
    register,
    formState: { errors }
  } = useFormContext<Schema>();
  const itemErrors = errors.items?.bloodLipidTest;

  return (
    <Panel>
      <Headding>血中脂質検査</Headding>
      <Item>
        <div>
          <Label>実施有無</Label>
          <Spacer size={8} />
          <RadioContainer>
            <Radio {...register('items.bloodLipidTest.checked')} value="true">
              実施
            </Radio>
            <Radio {...register('items.bloodLipidTest.checked')} value="false">
              未実施
            </Radio>
          </RadioContainer>
          {itemErrors?.checked?.message && <ErrorMessage>{itemErrors.checked.message}</ErrorMessage>}
        </div>
        <div className="u-mt20">
          <Label>結果</Label>
          <Spacer size={8} />
          <Textarea {...register('items.bloodLipidTest.value')} rows={3} isError={!!itemErrors?.value} />
          {itemErrors?.value?.message && <ErrorMessage>{itemErrors.value.message}</ErrorMessage>}
        </div>
        <div className="u-mt20">
          <Label>評価</Label>
          <Spacer size={8} />
          <Textarea {...register('items.bloodLipidTest.evaluation')} rows={3} isError={!!itemErrors?.evaluation} />
          {itemErrors?.evaluation?.message && <ErrorMessage>{itemErrors.evaluation.message}</ErrorMessage>}
        </div>
        <div className="u-mt20">
          <Label>所見有無</Label>
          <Spacer size={8} />
          <RadioContainer>
            <Radio {...register('items.bloodLipidTest.hasFinding')} value="false">
              所見なし
            </Radio>
            <Radio {...register('items.bloodLipidTest.hasFinding')} value="true">
              所見あり
            </Radio>
          </RadioContainer>
          {itemErrors?.hasFinding?.message && <ErrorMessage>{itemErrors.hasFinding.message}</ErrorMessage>}
        </div>
      </Item>
    </Panel>
  );
};
